<template>
  <div id="app" :dir="'rtl'">
    <NavBar />
    <router-view />
    <WhatsAppFloat />
  </div>
</template>

<script setup>
import NavBar from "./components/NavBar.vue";
import WhatsAppFloat from "./components/WhatsAppFloat.vue";
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700;900&family=Playfair+Display:wght@400;700;900&family=Montserrat:wght@300;400;600;700&display=swap");

:root {
  --bg-dark: #030712;
  --bg-navy: #0a1628;
  --bg-card: #0d1f3c;
  --gold: #d4af37;
  --gold-light: #f0c856;
  --gold-dark: #9a7b1c;
  --gold-glow: rgba(212, 175, 55, 0.25);
  --white: #f5f5f0;
  --gray: #8899aa;
  --border: rgba(212, 175, 55, 0.2);
}

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  scroll-behavior: smooth;
}

body {
  background: var(--bg-dark);
  color: var(--white);
  font-family: "Cairo", sans-serif;
  direction: rtl;
  overflow-x: hidden;
}

a {
  text-decoration: none;
  color: inherit;
}

::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  background: var(--bg-dark);
}
::-webkit-scrollbar-thumb {
  background: var(--gold-dark);
  border-radius: 3px;
}

.section-title {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 900;
  text-align: center;
  margin-bottom: 1rem;
  background: linear-gradient(
    135deg,
    var(--gold-light),
    var(--gold),
    var(--gold-dark)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-subtitle {
  text-align: center;
  color: var(--gray);
  font-size: 1.1rem;
  margin-bottom: 3.5rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.gold-divider {
  width: 80px;
  height: 3px;
  background: linear-gradient(90deg, transparent, var(--gold), transparent);
  margin: 1rem auto 2rem;
  border-radius: 2px;
}
</style>
